import React, { useState } from 'react';

const sucursales = [
  {
    nombre: 'División del Norte',
    numeros: [
      { label: '55 5603 0293', tel: '5255560302393' },
      { label: '55 5920 7323', tel: '5255592073233' },
      { label: '55 7511 0551', tel: '5255751105511' },
      { label: '55 4958 0007', tel: '5255495800071' },
    ],
  },
  {
    nombre: 'Mercado La Paz, Tlalpan',
    numeros: [{ label: '55 5162 5292', tel: '5255516252922' }],
  },
  {
    nombre: 'Cuemanco',
    numeros: [{ label: '55 9278 4907', tel: '5255927849073' }],
  },
  {
    nombre: 'Mercado Villa Coapa',
    numeros: [{ label: '55 5671 3059', tel: '5255567130594' }],
  },
];

const PhoneFloat: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 left-6 z-[9999] flex flex-col items-start gap-2">
      {/* Panel de números */}
      {open && (
        <div className="bg-[#05603c] border border-brand-deep rounded-2xl shadow-brand-strong p-4 w-[260px] max-h-[70vh] overflow-y-auto">
          <p className="text-white font-bold text-sm mb-3 uppercase tracking-wide">📞 Elige una sucursal</p>
          {sucursales.map((suc) => (
            <div key={suc.nombre} className="mb-3">
              <p className="text-[#ff6d00] text-xs font-bold uppercase mb-1">{suc.nombre}</p>
              {suc.numeros.map((n) => (
                <a
                  key={n.tel}
                  href={`tel:+${n.tel}`}
                  className="flex items-center gap-2 text-white text-sm py-1.5 px-3 rounded-lg hover:bg-brand-deep hover:text-white transition-colors duration-200 block"
                >
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-[#ff6d00] shrink-0" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.5 11.5 0 003.6.57 1 1 0 011 1V20a1 1 0 01-1 1C9.39 21 3 14.61 3 7a1 1 0 011-1h3.5a1 1 0 011 1 11.5 11.5 0 00.57 3.6 1 1 0 01-.24 1.01l-2.21 2.18z"/>
                  </svg>
                  {n.label}
                </a>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* Botón circular */}
      <button
        onClick={() => setOpen(!open)}
        aria-label="Llamar a El Chel"
        className="relative w-14 h-14 rounded-full bg-brand-deep flex items-center justify-center shadow-brand-strong hover:scale-110 transition-transform duration-300"
      >
        <span className="absolute inset-0 rounded-full bg-brand-deep animate-ping opacity-30" />
        <svg viewBox="0 0 24 24" className="w-7 h-7 fill-white relative z-10" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.5 11.5 0 003.6.57 1 1 0 011 1V20a1 1 0 01-1 1C9.39 21 3 14.61 3 7a1 1 0 011-1h3.5a1 1 0 011 1 11.5 11.5 0 00.57 3.6 1 1 0 01-.24 1.01l-2.21 2.18z"/>
        </svg>
      </button>
    </div>
  );
};

export default PhoneFloat;
